import _ from "lodash";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { CommunicationCapabilities } from "@/clients/ntas/basic-selfcare";

interface TNStore {
    capabilities: CommunicationCapabilities;
    setCapabilities: (capabilities: CommunicationCapabilities) => void;
    clearCapabilities: () => void;
}

const useCapabilitiesStore = create<TNStore>()(
    persist(
        (set) => ({
            capabilities: {} as CommunicationCapabilities,
            setCapabilities: (capabilities) => set(() => ({ capabilities })),
            clearCapabilities: () => set(() => ({ capabilities: {} as CommunicationCapabilities })),
        }),
        {
            name: "capabilities",
            storage: createJSONStorage(() => sessionStorage),
            skipHydration: true,
        },
    ),
);

export const checkStoredBusinessAttendantCapability = () => {
    const { capabilities } = useCapabilitiesStore();
    return capabilities?.autoAttendant !== undefined;
};

export const checkStoredScheduleCapability = () => {
    const { capabilities } = useCapabilitiesStore();
    // Looping through all different child elements, check for key "predefinable", and the value is PREDEFINABLE not NONE
    return _.some(capabilities, { predefinable: "PREDEFINABLE" });
};

export default useCapabilitiesStore;
